import { ContentLayoutWrapper } from '@framework/ui';
import { Col, Layout, Row } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';
const { Header } = Layout;

const StyledHeader = styled(Header)`
  &&& {
    width: 100%;
    padding: 0 16px;
    z-index: 11;
    height: ${props => props.theme.layoutHeaderHeight}px;
    line-height: ${props => props.theme.layoutHeaderContentHeight}px;
    &.has-shadow {
      box-shadow: ${props => props.theme.boxShadowCustomLine};
    }
    &.fixed-header {
      position: fixed;
    }
  }
`;

const RowNoWrap = styled(Row)`
  flex-wrap: nowrap;
  height: ${props => props.theme.layoutHeaderContentHeight}px;
  max-width: 100%;
`;
const ColFixed = styled(Col)`
  flex: 0 0 auto;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
`;
const ColLogo = styled(Col)`
  flex: 0 0 auto;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
`;
const ColAuto = styled(Col)`
  flex: 1 1 0;
  min-width: 0;
  max-height: ${props => props.theme.layoutHeaderContentHeight}px;
  overflow: hidden;
  justify-content: end;
`;

export interface HeaderTopLayoutProps {
  boxed?: boolean;
  fixed?: boolean;
  /** In caso sotto la Top Header sia presente una seconda riga con il titolo,
   *  viene divisa da un filo disegnato con la shadow */
  shadow?: boolean;
  /** Colonna sinistra per il logo */
  logo?: React.ReactNode;
  /** Colonna centrale per il menu princiale */
  main?: React.ReactNode;
  /** Colonna destra per il menu utente */
  right?: React.ReactNode;
}

/**
 * Fascia in alto della pagina che contiene il logo,
 * il menu principale, il menu delle notifiche e quello dell'utente
 */
export function HeaderTopLayout(props: HeaderTopLayoutProps) {
  const { logo, boxed, fixed, main, right, shadow } = props;

  return (
    <StyledHeader
      className={clx({ 'fixed-header': fixed, 'has-shadow': shadow })}
    >
      <ContentLayoutWrapper boxed={boxed}>
        <RowNoWrap align="middle">
          {logo && <ColLogo>{logo}</ColLogo>}
          <ColAuto>{main}</ColAuto>
          <ColFixed>{right}</ColFixed>
        </RowNoWrap>
      </ContentLayoutWrapper>
    </StyledHeader>
  );
}
